export default [
    {
        path: "/documents",
        name: "documents",
        component: require("../components/modules/document/DocumentList.vue")
            .default
    },
    {
        path: "/documents/new",
        name: "new document",
        component: require("../components/modules/document/DocumentCard.vue")
            .default
    },
    {
        path: "/documents/:id",
        name: "document",
        component: require("../components/modules/document/DocumentCard.vue")
            .default,
        props: true
    }
];
